import React, { useState, useEffect, useRef, useMemo } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { setBreadcrumb } from "../../redux/slices/breadCrumb.slice";
import { notifications } from "@mantine/notifications";
import ExportIcon from "../../svg/exportIcon";
import FloorIcon from "../../svg/floorIcon";
import { useGetStatsQuery } from "../../hooks/hooks";
import BagIcon from "../../svg/bag";
import WarrningIcon from "../../svg/warrning";
import { MdErrorOutline } from "react-icons/md";
import {
  fileLinkSelector,
  setFileLink,
  statsSelector,
} from "../../redux/slices/reports.slice";
import SiteIcon from "../../svg/addressIcon";
import { useAppSelector } from "../../redux/hooks";
import { TbZoomQuestion } from "react-icons/tb";
import PermissionAction from "../../components/permissions/PermissionAction";
import { LuClock3 } from "react-icons/lu";
import { GoQuestion } from "react-icons/go";

import ChairIcon from "../../svg/chairIcon";

import {
  useLazyGetReportsQuery,
  useLazyExportReportsQuery,
} from "../../redux/slices/api.slice";
import {
  Loader,
  Button,
  Tooltip,
  Modal,
  Radio,
  MultiSelect,
} from "@mantine/core";
import { DatePickerInput, DateTimePicker, TimeInput } from "@mantine/dates";
import CustomSelect from "../../components/CustomSelect";
import {
  useGetLocationsQuery,
  useLazyGetFloorsQuery,
} from "../../redux/slices/api.slice";

import {
  formatedDate,
  formatedTime,
  formatedFullDate,
  GetHours,
} from "../../utils/general";
import "../log/log.css";

import LineChart from "../../components/charts/LineChart";
import BarChart from "../../components/charts/BarChart";
import DeskOption from "../../components/DeskOption";
import CustomMultiSelect from "../../components/CustomMultiSelect";
import Container from "../../components/Container";
import { desksSelectionType, floorStats } from "../../interfaces/reports";

// Utility to parse time and set hours in a Date object
const parseTime = (timeString: string, referenceDate: Date) => {
  const [hours, minutes] = timeString.split(":").map(Number);
  const newDate = new Date(referenceDate);
  newDate.setHours(hours, minutes, 0, 0);
  return newDate;
};

const Reports = () => {
  const dispatch = useAppDispatch();
  const reportFile = useAppSelector((state) => fileLinkSelector(state));
  const stats = useAppSelector((state) => statsSelector(state));

  const {
    data: allLocations,
    isLoading: loadingLocations,
    isFetching: isFetchinglocations,
    isError: isErrorLocations,
  } = useGetLocationsQuery("");

  const [
    getFloors,
    {
      data: allFloors,
      isLoading: loadingFloors,
      isError: errorFloors,
      isFetching: isFetchingFloors,
    },
  ] = useLazyGetFloorsQuery();

  const [
    exportReport,
    {
      data: reports,
      isLoading: isLoadingReports,
      isError: isErrorReport,
      isFetching: isFetchingExport,
    },
  ] = useLazyGetReportsQuery();

  const [
    exportReportOnly,
    { isLoading: isLoadingExportOnly, isFetching: isFetchingExportOnly },
  ] = useLazyExportReportsQuery();

  useEffect(() => {
    const crumbs = [
      { name: "Home", route: "/" },
      { name: "Reports", route: "/reports" },
    ];
    dispatch(setBreadcrumb(crumbs));
  }, []);

  const initialStartTime = new Date();
  initialStartTime.setDate(initialStartTime.getDate() - 1);
  initialStartTime.setHours(8, 0, 0, 0);

  const initialEndTime = new Date();
  initialEndTime.setHours(initialEndTime.getHours(), 0, 0, 0);

  const [startTime, setStartTime] = useState<Date>(initialStartTime);
  const [endTime, setEndTime] = useState<Date>(initialEndTime);
  const [error, setError] = useState<string | null>(null);

  const [locationID, setLocationID] = useState("");
  const [defaultlocationID1, setDefaultLocationID1] = useState("");
  const [defaultlocationID2, setDefaultLocationID2] = useState("");
  const [desksSelection, setDeskSelection] =
    useState<desksSelectionType | null>(null);
  const [deskMap, setDeskMap] = useState(null);
  const [selectedFloor, setSelectedFloor] = useState("");
  const [clearReportFile, setClearReportFile] = useState(false);

  const [deskRange, setDeskRange] = useState(null);

  const [selectedType, setSelectedType] = useState([
    "frequency",
    "occupancy",
    "utilization",
  ]);
  const [type, setType] = useState([]);

  const types = ["occupancy", "utilization"];
  const [reportsData, setReportData] = useState<{}>(null);
  const [floors, setFloors] = useState([]);
  const [specModal, setSpecModal] = useState(false);
  const [locations, setLocations] = useState([]);
  const [isExport, setIsExport] = useState(false);
  const [reportParams, setReportParams] = useState({
    locationID: "",
    floorID: [],
  });
  const estimatedTime = 50;
  const [counter, setCounter] = useState(0);
  const { isLoading: isLoadingStats, isError: isErrorStats } = useGetStatsQuery(
    locationID,
    {
      skip: !locationID,
    },
  );
  const { isLoading: isLoadingStatsDefault1, isError: isErrorStatsDefault1 } =
    useGetStatsQuery(defaultlocationID1, {
      skip: !defaultlocationID1,
    });
  const { isLoading: isLoadingStatsDefault2, isError: isErrorStatsDefault2 } =
    useGetStatsQuery(defaultlocationID2, {
      skip: !defaultlocationID2,
    });

  useEffect(() => {
    if (isExport) {
      let id;
      if (counter < estimatedTime) {
        id = setInterval(() => {
          setCounter((prev) => prev + 1);
        }, 1000);
      }
      return () => {
        clearInterval(id);
      };
    }
  }, [estimatedTime, counter, isExport]);

  useEffect(() => {
    if (reportParams.floorID.length > 0) {
      const initalSelection = {};
      const initialMap = {};
      const initialRange = {};

      reportParams.floorID.forEach((el) => {
        initalSelection[el] = {
          deskOption: desksSelection?.[el]?.deskOption || "",
          startDeskID: desksSelection?.[el]?.startDeskID || "",
          endDeskID: desksSelection?.[el]?.endDeskID || "",
          singleDeskId: desksSelection?.[el]?.singleDeskId || "",
        };
        initialMap[el] = deskMap?.[el] || [];
        initialRange[el] = deskRange?.[el] || [];
      });

      setDeskSelection(initalSelection);
      setDeskMap(initialMap);
      setDeskRange(initialRange);
      return;
    }
  }, [reportParams.floorID]);

  useEffect(() => {
    dispatch(setFileLink(""));
  }, [clearReportFile]);

  useEffect(() => {
    const updated = allFloors?.map((floor) => {
      return { label: floor.name, value: floor.id };
    });
    updated && !errorFloors ? setFloors(updated) : setFloors([]);
  }, [allFloors, errorFloors]);

  useEffect(() => {
    const updated = allLocations?.map((loc) => {
      return { label: loc.name, value: loc.id };
    });
    updated && !isErrorLocations ? setLocations(updated) : setLocations([]);
  }, [allLocations, isErrorLocations]);

  useEffect(() => {
    if (reportParams.locationID) {
      getFloors(reportParams.locationID);
    }
    setReportParams({
      ...reportParams,
      floorID: [],
    });

    setDeskSelection(null);
    setDeskMap(null);
  }, [reportParams.locationID]);

  useEffect(() => {
    if (reports) {
      setReportData(reports);
    }
  }, [reports]);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (progress !== 100) {
      const result = Math.min(99, (counter * 100) / estimatedTime).toFixed(2);
      setProgress(Number(result));
    }
  }, [counter]);

  useEffect(() => {
    if (reportFile) {
      setProgress(100);
      const link = document.createElement("a");
      link.href = reportFile as string;
      link.setAttribute("download", `export.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setClearReportFile((prev) => !prev);
      setIsExport(false);
    }
  }, [reportFile, counter]);

  // Function to handle date changes (keeping the time part unchanged)
  const handleStartDateChange = (date: Date | null) => {
    if (date) {
      setStartTime((prev) => {
        const updated = new Date(prev);
        updated.setFullYear(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        );
        validateTimes(updated, endTime); // Validate times
        return updated;
      });
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    if (date) {
      setEndTime((prev) => {
        const updated = new Date(prev);
        updated.setFullYear(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
        );
        validateTimes(startTime, updated); // Validate times
        return updated;
      });
    }
  };

  const parseTimeWithFixedMinutes = (
    timeString: string,
    prevDate: Date,
    fixedMinutes: number,
  ) => {
    const [hours] = timeString.split(":").map(Number);
    const updated = new Date(prevDate);
    updated.setHours(hours, fixedMinutes, 0, 0);
    return updated;
  };

  const handleStartHourChange = (timeString: string) => {
    setStartTime((prev) => {
      const updated = parseTimeWithFixedMinutes(timeString, prev, 0);
      validateTimes(updated, endTime);
      return updated;
    });
  };

  const handleEndHourChange = (timeString: string) => {
    setEndTime((prev) => {
      const updated = parseTimeWithFixedMinutes(timeString, prev, 0);
      validateTimes(startTime, updated);
      return updated;
    });
  };

  const validateTimes = (start: Date, end: Date) => {
    // Compare dates
    const startDate = new Date(
      start.getFullYear(),
      start.getMonth(),
      start.getDate(),
    );
    const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate());

    if (startDate > endDate) {
      setError("Start date & hour cannot be greater than End date & hour");
    } else if (
      startDate.getTime() === endDate.getTime() ||
      startDate < endDate
    ) {
      const startTime = start.getHours() * 60 + start.getMinutes();
      const endTime = end.getHours() * 60 + end.getMinutes();

      if (startTime > endTime) {
        setError("Start date & hour cannot be greater than End date & hour");
      } else {
        setError(null);
      }
    } else {
      setError(null);
    }
  };
  const exportData = async () => {
    try {
      const result = await exportReportOnly(
        {
          startHour: GetHours(startTime),
          endHour: GetHours(endTime),
          startDate: formatedDate(startTime),
          endDate: formatedDate(endTime),
          type: selectedType,
          // floorID: reportParams.floorID,
          desks: deskMap,
          export: true,
        },
        false,
      );

      //@ts-ignore
      if (result.data) {
        setIsExport(true);
      } else {
        notifications.show({
          title: "Error",
          message: "something went wrong , try again!",
          color: "red",
        });
      }
    } catch (err) {
      notifications.show({
        title: "Error",
        message: "something went wrong , try again!",
        color: "red",
      });
    }
  };
  const fetchReportData = () => {
    exportReport({
      startHour: GetHours(startTime),
      endHour: GetHours(endTime),
      startDate: formatedDate(startTime),
      endDate: formatedDate(endTime),
      type: type,
      desks: deskMap,
      export: false,
    });
  };

  // calculate floor stats
  const calculateFloorStats = (locationStat) => {
    if (locationStat?.length > 0) {
      const activeFloors = locationStat.filter((floor) => floor.Live).length;
      let occupiedDesks = 0,
        underMaintenance = 0,
        blocked = 0,
        unassigned = 0,
        total = 0;

      locationStat.forEach((floor) => {
        if (floor.Live) {
          occupiedDesks += floor.DeskStats?.Occupied || 0;
          underMaintenance += floor.DeskStats?.UnderMaintenance || 0;
          blocked += floor.DeskStats?.Blocked || 0;
          unassigned += floor.DeskStats?.Unassigned || 0;
          total += floor.DeskStats?.Total || 0;
        }
      });

      const unavailableDesks =
        underMaintenance + unassigned + blocked + occupiedDesks;
      const availableDesks = total - unavailableDesks;
      const OOS = underMaintenance + unassigned + blocked;

      return [
        {
          label: "Active Floors",
          value: activeFloors,
          icon: SiteIcon,
          desc: "Total count of live floors within a site",
        },
        {
          label: "Available Desks",
          value: availableDesks,
          icon: ChairIcon,
          desc: "Total count of available desks across all active floors within a site",
        },
        {
          label: "Desk Occupation",
          value: occupiedDesks,
          icon: BagIcon,
          desc: "Total count of occupied desks across all active floors within a site",
        },
        {
          label: "Out Of Service Desks",
          value: OOS,
          icon: WarrningIcon,
          desc: "Total count of out of service desks across all active floors within a site",
        },
      ];
    }
    return [];
  };

  // Helper function to calculate bar chart data
  const calculateBarChartData = (locationStat) => {
    if (locationStat?.length > 0) {
      return locationStat
        .filter((f) => f.Live)
        .map((floor) => {
          const unoccupied =
            floor.DeskStats.Total -
            (floor.DeskStats.Occupied +
              floor.DeskStats.UnderMaintenance +
              floor.DeskStats.Blocked +
              floor.DeskStats.Unassigned);
          return {
            occupied: floor.DeskStats.Occupied,
            unoccupied,
            floor: floor.FloorName,
            oos:
              floor.DeskStats.Unassigned +
              floor.DeskStats.Blocked +
              floor.DeskStats.UnderMaintenance,
          };
        });
    }
    return [];
  };

  // Memoized spaceData and barChartData
  const spaceData = useMemo(
    () => calculateFloorStats(stats?.[locationID] || []),
    [stats, locationID],
  );
  const spaceDataDefault1 = useMemo(
    () => calculateFloorStats(stats?.[defaultlocationID1] || []),
    [stats, defaultlocationID1],
  );
  const spaceDataDefault2 = useMemo(
    () => calculateFloorStats(stats?.[defaultlocationID2] || []),
    [stats, defaultlocationID2],
  );

  const barChartData = useMemo(
    () => calculateBarChartData(stats?.[locationID] || []),
    [stats, locationID],
  );
  const barChartDataDefault1 = useMemo(
    () => calculateBarChartData(stats?.[defaultlocationID1] || []),
    [stats, defaultlocationID1],
  );
  const barChartDataDefault2 = useMemo(
    () => calculateBarChartData(stats?.[defaultlocationID2] || []),
    [stats, defaultlocationID2],
  );

  const dataSet = useMemo(() => {
    return reportsData
      ? Object.entries(reportsData)
          .map(([key, value]) => {
            const v =
              value &&
              Object.entries(value).map(([k, v]) => {
                return { date: new Date(k), value: v, name: key };
              });
            return v || [];
          })
          .flat()
      : [];
  }, [reportsData]);

  const isExportEnabled =
    reportParams.locationID && reportParams.floorID.length > 0 ? true : false;
  useEffect(() => {
    if (locations.length > 0) {
      setDefaultLocationID1(locations[0].value);
      setDefaultLocationID2(locations[1].value);
    }
  }, [locations]);

  return (
    // <PermissionAction operation="R" resource="reports">
    <Container>
      <div className="flex flex-col gap-20 ">
        <div>
          <div className="flex justify-between md:items-center  flex-col md:flex-row ">
            <h1 className="text-4xl sm:text-5xl font-[500] ">Site Reports</h1>
            <p className="text-base text-grayText3 my-3 block md:hidden">
              Get a comprehensive summary of desk availability statistics for
              your chosen site
            </p>

            <div className="flex flex-col md:w-auto w-full">
              <span className=" text-sm mb-1">Site</span>
              <CustomSelect
                data={locations}
                value={locationID}
                setValue={(value) => {
                  setLocationID(value);
                }}
                placeholder={""}
                isLoading={isFetchinglocations}
              />
            </div>
          </div>
          <p className="text-base text-grayText3 my-3 hidden md:block">
            Get a comprehensive summary of desk availability statistics for your
            chosen site
          </p>
          {locationID && (
            <div className="flex gap-6 items-center my-8">
              <div className="flex gap-6  items-center">
                <div className="flex flex-col gap-1">
                  <div className="flex gap-2">
                    <SiteIcon width={20} height={20} />
                    <span className="text-lg font-medium">Site</span>
                  </div>
                  <div className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm">
                    {locations.find((loc) => loc.value === locationID).label}
                  </div>
                </div>
              </div>
            </div>
          )}
          {!locationID && defaultlocationID1 && defaultlocationID2 && (
            <div className="flex gap-6 items-center my-8">
              <div className="flex gap-6  items-center">
                <div className="flex flex-col gap-1">
                  <div className="flex gap-2">
                    <SiteIcon width={20} height={20} />
                    <span className="text-lg font-medium">Site</span>
                  </div>
                  <div className="flex gap-2">
                    <div className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm">
                      {
                        locations.find(
                          (loc) => loc.value === defaultlocationID1,
                        ).label
                      }
                    </div>
                    <div className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm">
                      {
                        locations.find(
                          (loc) => loc.value === defaultlocationID2,
                        ).label
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="rounded-[20px]  mt-8 border xl:h-[600px] h-fit  border-solid border-grayText4 py-5 px-8 w-full">
            {isLoadingStats ? (
              <div className="flex h-[400px] xl:h-full items-center justify-center">
                <Loader size="lg" />
              </div>
            ) : isErrorStats ? (
              <div className="flex  flex-col items-center justify-center h-[400px] xl:h-full text-grayText ">
                <MdErrorOutline size={70} className="mb-2" />

                <p className=" text-xl sm:text-3xl font-medium"> Error </p>
              </div>
            ) : !locationID ? (
              <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-8">
                <DataSection
                  isLoading={isLoadingStatsDefault1}
                  spaceData={spaceDataDefault1}
                  barChartData={barChartDataDefault1}
                  defaultLocationID={defaultlocationID1}
                />
                <DataSection
                  isLoading={isLoadingStatsDefault2}
                  spaceData={spaceDataDefault2}
                  barChartData={barChartDataDefault2}
                  defaultLocationID={defaultlocationID2}
                />
              </div>
            ) : spaceData?.length === 0 ? (
              <div className="flex  h-[400px] xl:h-full   flex-col items-center justify-center  text-grayText ">
                <TbZoomQuestion size={70} className="mb-2" />

                <span className="text-xl sm:text-3xl font-medium">
                  No Active Floors Present
                </span>
              </div>
            ) : (
              <div className="grid lg:grid-cols-2 gap-16 lg:gap-4  h-fit w-full grid-cols-1">
                <div className="grid grid-cols-2  gap-12 place-content-center mt-5 lg:mt-0  h-full md:pl-5 ">
                  {spaceData?.map((space, index) => {
                    const Icon = space.icon;
                    return (
                      <div
                        className="flex flex-col justify-center md:justify-start  md:items-start items-center rounded-[10px]"
                        key={space.label}
                      >
                        <div className="bg-actionLight text-action flex items-center  justify-center w-[60px] h-[60px] rounded-full ">
                          <Icon fill="#FB6514" width={31} height={28} />
                        </div>
                        <h2 className="text-[60px] m-0 font-[500]">
                          {space.value}
                        </h2>
                        <div className="flex gap-2 items-center">
                          <p className="text-lg text-grayText2 m-0">
                            {space.label}
                          </p>
                          <Tooltip
                            className="w-[200px] "
                            withArrow
                            label={
                              <span className="text-wrap ">{space.desc}</span>
                            }
                          >
                            <div className="flex justify-center">
                              <GoQuestion color="#98A2B3" />
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="flex gap-10 items-center w-full">
                  <BarChart dataSet={barChartData} />
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          <h1 className="text-4xl sm:text-5xl font-[500] ">Floor Reports</h1>
          <p className="text-base text-grayText3 my-3">
            Explore workspace statistics tailored to your chosen parameters,
            empowering you with targeted data for making informed workspace
            decisions
          </p>

          <div className=" mt-5  md:w-full">
            {reportParams.locationID && reportParams.floorID.length > 0 && (
              <div className="grid grid-cols-2 sm:flex  gap-6 ">
                <div className="flex flex-col gap-1">
                  <div className="flex gap-2">
                    <SiteIcon width={20} height={20} />
                    <span className="text-base font-medium">Site</span>
                  </div>
                  <div className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm">
                    {
                      locations.find(
                        (loc) => loc.value === reportParams.locationID,
                      ).label
                    }
                  </div>
                </div>

                <div className="flex flex-col gap-1 order-2 sm:order-1 ">
                  <div className="flex gap-2  ">
                    <FloorIcon width={20} height={20} />
                    <span className="text-base font-medium">
                      {reportParams.floorID.length > 1 ? "Floors" : "Floor"}
                    </span>
                  </div>
                  {reportParams.floorID.map((floorID, index) => {
                    return (
                      <div
                        key={floorID}
                        className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm "
                      >
                        {floors.find((floor) => floor.value === floorID)?.label}
                      </div>
                    );
                  })}
                </div>

                <div className="flex flex-col gap-1 order-3 sm:order-1 ">
                  <div className="flex gap-2">
                    <ChairIcon width={20} height={20} />
                    <span className="text-base font-medium">Desks</span>
                  </div>
                  {desksSelection &&
                    Object.entries(desksSelection).map(
                      ([key, value], index) => {
                        return value.deskOption === "all" ? (
                          <div
                            key={key}
                            className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm min-w-[100px]  max-w-[150px] "
                          >
                            All
                          </div>
                        ) : value.deskOption === "single" ? (
                          <Tooltip
                            className="max-w-[200px] "
                            withArrow
                            key={key}
                            label={
                              <span className="text-wrap">
                                {value.singleDeskId?.split("-")[0]}
                              </span>
                            }
                          >
                            <div className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm    max-w-[150px] min-w-[100px]   truncate">
                              <span>{value.singleDeskId?.split("-")[0]}</span>
                            </div>
                          </Tooltip>
                        ) : (
                          deskRange?.[key].length > 0 && (
                            <Tooltip
                              className="max-w-[200px] "
                              withArrow
                              key={key}
                              label={
                                <span className="text-wrap">{`${
                                  deskRange[key][0]?.split("-")[0]
                                }...${
                                  deskRange[key]?.[
                                    deskRange[key].length - 1
                                  ]?.split("-")[0]
                                }`}</span>
                              }
                            >
                              <div className="bg-lightGray flex text-grayText rounded-[10px] px-3 py-1 text-sm  w-fit  min-w-[100px]  max-w-[150px]  truncate ">
                                {deskRange[key].map((desk, index) => {
                                  return (
                                    <div key={desk}>
                                      <span>{desk?.split("-")[0]}</span>
                                      {index !== deskRange[key].length - 1 && (
                                        <span>,</span>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            </Tooltip>
                          )
                        );
                      },
                    )}
                </div>

                <div className="flex flex-col gap-1 sm:order-3 ">
                  <div className="flex gap-2 items-center">
                    <LuClock3 className="text-xl text-grayText3" />
                    <span className="text-base font-medium">Time Range</span>
                  </div>
                  <div className="bg-lightGray text-grayText rounded-[10px] px-3 py-1 text-sm w-fit">
                    {`${formatedFullDate(startTime)} - ${formatedFullDate(
                      endTime,
                    )}`}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="flex justify-between items-center mt-5 mb-8 ">
            <div
              onClick={() => setSpecModal(true)}
              className="rounded-lg h-fit uppercase  border border-dashed border-grayText hover:bg-lightGray p-2 flex items-center justify-center text-grayText cursor-pointer "
            >
              {reportParams.locationID && reportParams.floorID.length > 0 ? (
                <span>edit Parameters</span>
              ) : (
                <span>add Parameters</span>
              )}
            </div>
            <Button
              color={"#D5DAE1"}
              variant="default"
              disabled={!isExportEnabled}
              radius="xl"
              size="lg"
              loaderProps={{ type: "dots" }}
              className={`w-full  ${
                isExportEnabled ? "!text-[#404F65]" : "!text-[#D5DAE1]"
              }`}
              onClick={() => {
                exportData();
                // if flag is false
                setCounter(0);
                setProgress(0);
              }}
              leftSection={
                <ExportIcon fill={isExportEnabled ? "#404F65" : "#D5DAE1"} />
              }
            >
              Export
            </Button>
          </div>

          <div className="rounded-[20px] border  xl:h-[650px] h-fit   border-solid border-grayText4 p-5 w-full">
            {isFetchingExport ? (
              <div className="flex items-center justify-center  h-[400px] xl:h-full ">
                <Loader size="lg" />
              </div>
            ) : isErrorReport ? (
              <div className="flex  flex-col items-center justify-center  h-[400px] xl:h-full text-grayText ">
                <MdErrorOutline size={70} className="mb-2" />

                <p className="text-xl sm:text-3xl font-medium"> Error </p>
              </div>
            ) : reportParams.floorID.length === 0 ? (
              <div className="flex  flex-col items-center justify-center h-[400px] xl:h-full text-grayText ">
                <TbZoomQuestion size={70} className="mb-2" />

                <span className="text-xl sm:text-3xl font-medium">
                  No Parameter Selected{" "}
                </span>
              </div>
            ) : dataSet.length === 0 ? (
              <div className="flex  flex-col items-center justify-center  h-[400px] xl:h-full text-grayText ">
                <TbZoomQuestion size={70} className="mb-2" />

                <span className="text-xl sm:text-3xl font-medium">
                  No Data for the selected parameters
                </span>
              </div>
            ) : (
              <LineChart
                dataSet={dataSet}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                floors={floors}
                floorIDs={reportParams.floorID}
                selectedFloor={selectedFloor}
                setSelectedFloor={setSelectedFloor}
              />
            )}
          </div>
        </div>

        <Modal
          opened={specModal}
          onClose={() => setSpecModal(false)}
          size={800}
          radius={20}
        >
          <div className="p-3 flex flex-col gap-6">
            <div className="flex gap-2 items-center mb-2 ">
              <p className="text-2xl font-medium">Data Parameters Selection</p>
            </div>

            <div className="flex flex-col ">
              <span className="text-base font-medium mb-1">Site</span>
              <CustomSelect
                data={locations}
                value={reportParams.locationID}
                setValue={(value) => {
                  setReportParams({ ...reportParams, locationID: value });
                }}
                placeholder={""}
                isLoading={isFetchinglocations}
              />
            </div>
            <div className="flex flex-col ">
              <span className="text-base font-medium mb-1">Floors</span>
              <CustomMultiSelect
                setReportParams={setReportParams}
                data={floors}
                isLoading={isFetchingFloors}
                reportParams={reportParams}
              />
            </div>

            <div className="flex flex-col ">
              <span className="text-base font-medium mb-1">Types</span>
              <MultiSelect
                data={types}
                value={type}
                onChange={(val) => setType(val)}
                withScrollArea={false}
                clearable
                styles={{
                  dropdown: {
                    maxHeight: 180,
                    overflowY: "auto",
                    borderColor: "#BBC3CF",
                  },
                  input: { borderRadius: "8px", borderColor: "#BBC3CF" },
                }}
              />
            </div>
            <div className="flex gap-6 w-full">
              <div className="flex flex-col gap-1 w-full">
                <div className="flex gap-2 items-center mb-2">
                  <span className="m-0 text-base font-medium">
                    Start date & hour
                  </span>
                </div>

                <DatePickerInput
                  value={startTime}
                  onChange={handleStartDateChange}
                  placeholder="Pick start date"
                />

                <TimeInput
                  value={startTime.toTimeString().slice(0, 5)}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const timeString = event.target.value;
                    handleStartHourChange(timeString);
                  }}
                  placeholder="Pick start time"
                />
              </div>

              <div className="flex flex-col gap-1 w-full">
                <div className="flex gap-2 items-center mb-2">
                  <span className="m-0 text-base font-medium">
                    End date & hour
                  </span>
                </div>

                {/* Date Picker for End Date */}
                <DatePickerInput
                  value={endTime}
                  onChange={handleEndDateChange}
                  placeholder="Pick end date"
                />

                <TimeInput
                  value={endTime.toTimeString().slice(0, 5)}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const timeString = event.target.value;
                    handleEndHourChange(timeString);
                  }}
                  placeholder="Pick end time"
                />
                {error && <div className="text-red-500">{error}</div>}
              </div>
            </div>

            {reportParams.floorID.map((floor) => {
              const selection = desksSelection?.[floor];
              if (!selection) return null;
              const floorName = floors.find((f) => f.value === floor)?.label;
              return (
                <DeskOption
                  key={floor}
                  floorID={floor}
                  floorName={floorName}
                  selection={selection}
                  desksSelection={desksSelection}
                  setDeskSelection={setDeskSelection}
                  deskMap={deskMap}
                  setDeskMap={setDeskMap}
                  deskRange={deskRange}
                  setDeskRange={setDeskRange}
                  // setDeskAlias ={setDeskAlias}
                />
              );
            })}

            <div className="flex gap-4 justify-end ">
              <Button
                color="#FB6514"
                size="md"
                disabled={
                  reportParams.floorID.length === 0 ||
                  !reportParams.locationID ||
                  error !== null ||
                  (desksSelection &&
                    Object.values(desksSelection).some(
                      (d) => d.deskOption === "",
                    ))
                }
                onClick={() => {
                  setSpecModal(false);

                  fetchReportData();
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </Modal>

        <Modal
          opened={isExport}
          onClose={() => {
            setIsExport(false);
          }}
          radius={20}
          size={"lg"}
          withCloseButton={false}
        >
          <div className="flex flex-col py-5">
            <div className="flex flex-col items-center gap-2">
              <div
                className={`relative w-[150px] flex items-center bg-[#f8fafd] justify-center shadow-lg h-[150px] mx-auto  rounded-[50%] my-5 `}
              >
                <div className="ring" />
                <span className="text-3xl ">{`${progress}%`}</span>
              </div>

              <div className="flex flex-col items-center justify-center">
                <h2 className="font-medium text-lg">Downloading...</h2>
                <p className="text-base text-grayText3">
                  Your file will be ready shortly
                </p>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </Container>
    //  </PermissionAction>
  );
};
const SpaceItem = ({ space }) => {
  const Icon = space.icon;
  return (
    <div
      className="flex flex-col justify-center md:justify-start md:items-start items-center rounded-[10px]"
      key={space.label}
    >
      <div className="flex items-center gap-2">
        <div className="bg-actionLight text-action flex items-center justify-center w-[40px] h-[40px] rounded-full">
          <Icon fill="#FB6514" width={18} height={15} />
        </div>
        <h2 className="text-[16px] m-0 font-[500]">{space.value}</h2>
      </div>
      <div className="flex gap-2 mt-2 items-center">
        <p className="text-[12px] text-grayText2 m-0">{space.label}</p>
        <Tooltip
          className="w-[200px]"
          withArrow
          label={<span className="text-wrap">{space.desc}</span>}
        >
          <div className="flex justify-center">
            <GoQuestion color="#98A2B3" />
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

const DataSection = ({
  isLoading,
  spaceData,
  barChartData,
  defaultLocationID,
}) =>
  isLoading ? (
    <div className="flex h-[400px]  items-center justify-center">
      <Loader size="lg" />
    </div>
  ) : (
    <div className="grid lg:grid-cols-[auto,1fr] gap-16 lg:gap-2 h-fit w-full grid-cols-1">
      <div className="grid grid-cols-1 gap-8 place-content-center mt-5 lg:mt-0 h-full md:pl-5">
        {spaceData?.map((space) => (
          <SpaceItem key={space.label} space={space} />
        ))}
      </div>
      <div className="flex gap-10 items-center w-full">
        {defaultLocationID && <BarChart dataSet={barChartData} small={true} />}
      </div>
    </div>
  );

export default Reports;
